import clsx from 'clsx'
import Image, { ImageProps } from 'next/image'
import { ReactNode } from 'react'

import { Button } from '@/shared/ui'

import { Tabs, TabsProps } from './Tabs/Tabs'

import cl from './HeroBannerInfo.module.scss'

export interface HeroBannerInfoProps {
	className?: string
	title: ReactNode
	image: ImageProps
	text?: ReactNode
	buttonLabel?: string
	onClick?: () => void
	additional?: {
		title: ReactNode
		text: ReactNode
	}[]
	links?: TabsProps
	content?: ReactNode
}

export const HeroBannerInfo = (props: HeroBannerInfoProps) => {
	const { className, title, text, buttonLabel, onClick, image, additional = [], links, content } = props

	const additionalSlices = additional.slice(0, 3)

	return (
		<section className={clsx(cl.root, className)}>
			<div className={cl.main}>
				{!!links && <Tabs {...links} />}
				<div className={cl.main__content}>
					<div className={cl.main__info}>
						<h1 className={cl.title}>{title}</h1>
						{text}
					</div>
					<div className={cl.main__image}>
						<Image priority quality={100} alt="" {...image} />
					</div>
					{buttonLabel && (
						<div className={cl.main__button}>
							{content}
							<Button size="L" fullWidth onClick={onClick}>
								{buttonLabel}
							</Button>
						</div>
					)}
				</div>
			</div>
			{additionalSlices.length > 0 && (
				<div className={cl.additional}>
					{additionalSlices.map((item, index) => (
						<div key={index}>
							<h3>{item.title}</h3>
							<p>{item.text}</p>
						</div>
					))}
				</div>
			)}
		</section>
	)
}
